import { useState } from "react";

export enum LocalStorage {
  GoalFulfillmentFutureAmountEnabled = "GoalFulfillmentFutureAmountEnabled",
}

export const useLocalStorage = <T>(key: string, initialValue: T): [T, (value: T) => void] => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = localStorage.getItem(key);
      return item === null ? initialValue : (JSON.parse(item) as T);
    } catch (_) {
      return initialValue;
    }
  });

  const setValue = (value: T) => {
    try {
      setStoredValue(value);
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Failed to save to localStorage for key "${key}":`, error);
    }
  };

  return [storedValue, setValue];
};
